export default __webpack_public_path__ + "static/media/suite-montanha1-2.019d8524.webp";